__webpack_require__.p = "/quote-client/";